// types
import { TP_CoolingGenerator } from './types'
import { ParametersViewWrapper } from '../../../../features/ParametersView'

export function ParameterPanel(props: TP_CoolingGenerator) {

    return ( <ParametersViewWrapper parentId={props.id} resourceGroupId={props.resourceGroupId}></ParametersViewWrapper>   );
}

